import React, { Component } from 'react';
import 'react-dates/initialize';
import { Route } from 'react-router';
import { ServiceInformationPanel } from './components/controls/People/ServiceInformationPanel';
import { Home } from './components/Home';
import { Layout } from './components/Layout';
import { Admin } from './components/pages/Admin';
import { AdminList } from './components/pages/AdminList';
import { ChangePassword } from './components/pages/ChangePassword';
import { Enquire } from './components/pages/Enquire';
import { Forgotten } from './components/pages/Forgotten';
import { GroupEditor } from './components/pages/Groups/GroupEditor';
import { Logging } from './components/pages/Logging';
import { Login } from './components/pages/Login';
import { NoPermission } from './components/pages/NoPermission';
import { OwnerList } from './components/pages/OwnerList';
import { EditPageDetails } from './components/pages/PageDetails/EditPageDetails';
import { Equipment } from './components/pages/PageDetails/Equipment';
import { MeetTheTeam } from './components/pages/PageDetails/MeetTheTeam';
import { OurServices } from './components/pages/PageDetails/OurServices';
import { Testimonials } from './components/pages/PageDetails/Testimonials';
import { PersonEdit } from './components/pages/PersonEdit';
import { PersonView } from './components/pages/PersonView';
import { PetEdit } from './components/pages/PetEdit';
import { Pets } from './components/pages/Pets';
import { Planning } from './components/pages/Planning';
import { Prospects } from './components/pages/Prospects';
import { Onboarding } from './components/pages/Onboading';
import { SearchDb } from './components/pages/SearchDb';
import { SetAccount } from './components/pages/SetAccount';
import { StaffList } from './components/pages/StaffList';
import { WalkerList } from './components/pages/WalkerList';
import { UnitTestArcaDate } from './components/tests/UnitTestArcaDate';
import { UnitTestArcaTimeslot } from './components/tests/UnitTestArcaTimeslot';
import './custom.css';


export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={Home} />
                <Route exact path='/home' component={Home} />
                <Route exact path='/admin' component={Admin} />
                <Route exact path='/MeetTheTeam' component={MeetTheTeam} />
                <Route exact path='/Testimonials' component={Testimonials} />
                <Route exact path='/ServiceInfo' component={ServiceInformationPanel} />
                <Route exact path='/Equipment' component={Equipment} />
                <Route exact path='/OurServices' component={OurServices} />
                <Route path='/pets' component={Pets} />
                <Route path='/PersonView' component={PersonView} />

                <Route path='/PersonEdit' component={PersonEdit} />
                <Route path='/ChangePassword' component={ChangePassword} />
                <Route path='/Prospects' component={Prospects} />
                <Route path='/Onboarding' component={Onboarding} />
                <Route path='/walkerlist' component={WalkerList} />
                <Route path='/ownerlist' component={OwnerList} />
                <Route path='/stafflist' component={StaffList} />
                <Route path='/adminList' component={AdminList} />

                <Route path='/Planning' component={Planning} />
                <Route path='/Logging' component={Logging} />
                <Route path='/GroupEditor' component={GroupEditor} />
                <Route path='/EditPageDetails' component={EditPageDetails} />
                
                <Route path='/PetEdit' component={PetEdit} />
                <Route path='/Enquire' component={Enquire} />
                <Route path='/Forgotten' component={Forgotten} />
                <Route path='/login' component={Login} />
                <Route path='/setaccount' component={SetAccount} />
                <Route path='/SearchDb' component={SearchDb} />
                <Route path='/NoPermission' component={NoPermission} />
                <Route path='/UnitTestArcaDate' component={UnitTestArcaDate} />
                <Route path='/UnitTestArcaTimeslot' component={UnitTestArcaTimeslot} />
            </Layout>
        );
    }
}
